import styled from "styled-components";
import { Table } from "@mantine/core";

export const StyledTable = styled(Table)`
  width: 800px;

  .border-none {
    border: none;
  }

  .text-center {
    text-align: center;
  }
`;
